import React from "react";
import Helmet from "react-helmet";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// React icons
import { FaUndo } from 'react-icons/fa';

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

//sections
import ContactMeSection from "./Sections/ContactMeSection.jsx";

//styles
import contactPageStyle from "assets/jss/material-kit-react/views/contactPage.jsx";

class ContactPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Helmet title={"Jason M. Casebier"} />
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 185,
            color: "white"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/landing-bg.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={8}>
                <h1 className={classes.title}>Be heard.</h1>
                <h4>
                Something on your mind? I value your feedback and want to hear from you. Let me know what you think by completing the form below.
                </h4>
                <br />
                <Button
                  color="primary"
                  size="lg"
                  href="/"
                  rel="noopener noreferrer"
                >
                  <FaUndo/>
                  Go back
                </Button>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
            <ContactMeSection />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(contactPageStyle)(ContactPage);
